import { useQuery } from '@tanstack/react-query';
import { request, type Queue } from './editorial-client';
import { queuePolling } from './queue-polling';
export function useEditorialQueue() {
  return useQuery({
    queryKey: ['editorial-queue'],
    queryFn: () => request<Queue>(),
    refetchInterval: q => queuePolling(q.state.data?.runs),
    refetchIntervalInBackground: false,
    staleTime: 30_000,
  });
}
